import { cn } from '@/lib/utils/cn';

/** Shared visual contract for text-like form controls (input, textarea, select). */
export const fieldControlClassName = cn(
  'w-full min-w-0 rounded-lg border border-input bg-surface px-3 text-sm text-foreground shadow-xs',
  'transition-[color,border-color,box-shadow] duration-150 placeholder:text-subtle-foreground',
  'focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/15 focus-visible:outline-none',
  'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:opacity-60',
  'aria-invalid:border-danger aria-invalid:focus-visible:ring-danger/15',
);

// Layout/sizing utilities (optionally responsive) belong to the wrapper so the
// chevron stays inside the control when a width is set (e.g. `sm:w-56`).
const LAYOUT_CLASS = /^(?:[a-z0-9-]+:)*(?:w|min-w|max-w|basis|flex|grow|shrink)(?:-|$)/;

export function splitSelectClassName(className = ''): { wrapper: string; control: string } {
  const tokens = className.split(/\s+/).filter(Boolean);
  return {
    wrapper: tokens.filter((token) => LAYOUT_CLASS.test(token)).join(' '),
    control: tokens.filter((token) => !LAYOUT_CLASS.test(token)).join(' '),
  };
}
